import React, {Component} from 'react';
import {connect} from "react-redux";
import {Trans} from 'react-i18next';
import { withTranslation } from 'react-i18next';
import Icon from "../../../../../../components/icon";
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import {findLabels} from "../../../../../../../actions/contactsGroupItemActions";

class OverQuotaPopup extends Component {

    constructor(props){
        super(props);

        this.state = {
            isSyncing: false,
            isProcessFollowed: false
        };

        this.handleCheck = this.handleCheck.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    handleCheck(e){

        if(e.currentTarget.checked) {
            this.setState({
                isProcessFollowed: true
            });
        } else {
            this.setState({
                isProcessFollowed: false
            });
        }

    }

    handleSync(e){

        e.preventDefault();

        this.setState({
            isSyncing: true
        }, () => {
            setTimeout(() => {
                this.props.getSharingDetailsPopup([]);
                this.props.setFindLabels(this.props.labelsPageSize, true);
            }, 2000)
        });
    }

    render() {
        return (
            <div className="p-4">
                <h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{this.props.t("OverQuotaText")}</span></h2>
                <p>
                    {this.props.t("textStatusDescriptionOverQuota2")}<br/>
                    <Trans i18nKey="textOverQuotaContent" components={{a: <a href="https://www.getsharedcontacts.com/knowledge-base/how-to-solve-contact-limit-reached-in-google-contacts/"> </a>}} />
                </p>
                <div className="form-check mb-2">
                    <input onClick={this.handleCheck} className="form-check-input" type="checkbox" id="isResold" name="isResold"/>
                    <label className="form-check-label" htmlFor="isResold">
                    {this.props.t("textStatusDescriptionOverQuota1")}
                    </label>
                </div>
                <div className="text-right">
                    {
                        this.state.isSyncing === false
                            ?
                            <Button disabled={this.state.isProcessFollowed === false} onClick={this.handleSync} className="btn-primary">{this.props.t("textSync")}</Button>
                            :
                            <Button disabled={true} className="btn-primary">
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        profile : state.profileReducer.getProfile,
        selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup,
        sharingDetailsLv2Popup: state.sharingDetailsReducer.getSharingDetailsLv2Popup,
        labelsPageSize : state.contactsGroupItemReducer.labelsPageSize,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup: (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setFindLabels : (pageSize, directLaunch) => {
            dispatch(findLabels(pageSize, directLaunch))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OverQuotaPopup));
